import { IEngageCateogoryQuery } from '../interfaces/interfaces/engage-category.query.interface';

export class EngageCategory {
    category: {
        id: string;
        name: string;
        type: string;
        isSelected?: boolean;
        postingsCategoryId?: string;
    };

    children: EngageCategory[];
    numberOfResults: number;

    constructor(query: IEngageCateogoryQuery) {
        this.category = {
            id: String(query.category.id),
            name: query.category.name,
            type: query.category.type,
        };

        this.numberOfResults = query.number_of_results;

        this.children = query.children ? query.children.map((child) => new EngageCategory(child)) : [];
    }

    get isExpandable(): boolean {
        return (this.category.type === 'sub_categories' && this.children.length > 0) || (this.category.type === 'offerings' && this.numberOfResults > 0);
    }
}
